import type { Disposable, Model } from '@patsnap/tahiti-core';
import type { CurrentTaskInputState } from '../types';

export const CurrentTaskInputModel = Symbol.for('CurrentTaskInputModel');

/**
 * 当前任务的原始输入相关信息的模型
 */
export interface CurrentTaskInputModel extends Model<CurrentTaskInputState>, Disposable {}
